import { unsafeHTML } from "lit-html/directives/unsafe-html.js"
import { html, ovl, SYSConfig, TemplateResult } from "../../../_ovlclient/src"
import { _globals, isMobile, T } from "../../../_ovlclient/src/global/globals"
import {
  HookFieldValidationTextDisplay_ReturnType,
  HookFormSummaryValidationTextDisplay_ReturnType,
} from "../../../_ovlclient/src/global/hooks"
import {
  SummaryErrorList,
  SYSField,
  SYSFormState,
} from "../../../_ovlclient/src/library/forms/actions"
import { FieldIsFocused } from "../../src/library/forms/fieldapi"
import { ValidateResultError } from "../../src/library/forms/validators"
import { ValidationGetTranslation } from "../../src/library/forms/validatorsapi"

export const HandleOvlFocusIn = (e: Event) => {
  let focusId
  let target: HTMLElement = <HTMLElement>e.target
  if (target?.id) {
    focusId = target.id
  } else {
    return
  }

  if (focusId && !target.classList.contains("ovl-ignoreautofocus")) {
    // sets focus id which could be used in focus restore when switching screens/dialogs
    _globals.previousValidFocusId = _globals.lastValidFocusId
    _globals.lastValidFocusId = focusId
  }
  let el = document.getElementById(focusId)
  if (el && el.classList.contains("ovl-focusselected")) {
    try {
      setTimeout(() => {
        if (document.activeElement?.id === el.id) {
          //@ts-ignore
          el.select()
        }
      }, 100)
    } catch {}
  }
}

export const AppShellGet = (): TemplateResult => {
  // focusin remembers last focus when switching screens.
  // we don't want to remember focuses inside the shellbar itself
  // dont forget to add to your custom mainShell even when not using shellbar
  let ovlState = ovl.getState().ovl
  let appState = ovlState.app
  let scrollable = "scrollable"
  let appMainClass = ""
  if (appState.offline.api) {
    appMainClass = "ovl-offline "
  }
  if (appState.ready) {
    appMainClass = `${appMainClass} ovl-ready `
  }
  if (ovlState.uiState.isDemo) {
    appMainClass = `${appMainClass} ovl-test `
  }

  return html`
    <div
      class=${appMainClass}
      @focusin=${(e: FocusEvent) => {
        HandleOvlFocusIn(e)
      }}
    >
      <div id="SYSScreens" class=${scrollable}>
        <ovl-screencontainer> </ovl-screencontainer>
      </div>
      <div id="SYSDialogs">
        <ovl-dialogcontainer> </ovl-dialogcontainer>
        <ovl-snack> </ovl-snack>
      </div>
    </div>
  `
}

//default impl if no hook is found
export const FieldValidationTextGet = (
  field: SYSField,
  visibleErrors: ValidateResultError[]
): HookFieldValidationTextDisplay_ReturnType => {
  // don't rely on f.visible here because this gets set in setVisibleValidation hich is debounced for good reason...
  let res = visibleErrors.map((m, resIndex) => {
    let sep = ""
    if (resIndex > 0) {
      sep = ", "
    }
    return html`${unsafeHTML(
      `${sep}${T(m.translationKey, m.translationReps)}`
    )}`
  })
  return { res }
}

//default impl if no hook is found
export const FormSummaryValidationTextGet = (
  formState: SYSFormState,
  relevantErrors: SummaryErrorList[]
): HookFormSummaryValidationTextDisplay_ReturnType => {
  let res = {
    res: relevantErrors.map((m, resIndex) => {
      let sep = ""
      if (resIndex > 0) {
        sep = ", "
      }
      return html`${unsafeHTML(
        `${sep}${ValidationGetTranslation(
          formState,
          m.translationKey,
          m.translationReps,
          m.involvedFieldKeysMinusFocused
            ? m.involvedFieldKeysMinusFocused
            : [],
          m.involvedFieldKeys ? m.involvedFieldKeys.length > 1 : false
        )}`
      )}`
    }),
  }

  return res
}
